"use client";

import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "@/lib/firebase";
import { notificationService } from "@/api/notification";
import { playNotificationSound } from "@/lib/notificationSound";
import { toast } from "sonner";
import { useAuthStore } from "@/store/useAuthStore";

export function FCMHandler() {
  const { token: authToken } = useAuthStore();

  useEffect(() => {
    if (!authToken) return;

    const setupFCM = async () => {
      try {
        if (typeof window === "undefined" || !messaging) return;

        // 1. Request permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.log("Notification permission denied");
          return;
        }

        // 3. Get token
        const token = await getToken(messaging, {
          vapidKey: undefined,
        });

        if (token) {
          console.log("Admin FCM Token:", token);
          // 4. Send to backend
          await notificationService.setFcmToken({
            device_token: token,
          });
        }

        // 5. Handle foreground messages
        onMessage(messaging, (payload) => {
          console.log("Admin Message received in foreground:", payload);
          playNotificationSound();
          toast.info(payload.notification?.title || "New Notification", {
            description: payload.notification?.body,
          });
        });
      } catch (error) {
        console.error("Error setting up FCM in admin:", error);
      }
    };

    setupFCM();
  }, [authToken]);

  return null;
}
